export type FieldValueType = 'boolean' | 'currency' | 'number' | 'string'

export interface FieldConfig {
  label: string
  valueType: FieldValueType
}

export const FIELD_CONFIG: Record<string, FieldConfig> = {
  sort: { label: 'Sort', valueType: 'number' },
  serviceNotCovered: { label: 'Service Not Covered', valueType: 'boolean' },
  appliesToDeductible: { label: 'Applies To Deductible', valueType: 'boolean' },
  isGrouped: { label: 'Is Grouped', valueType: 'boolean' },
  coinsurance: { label: 'Coinsurance', valueType: 'number' },
  copayAmount: { label: 'Copay Amount', valueType: 'currency' },
  copayDayLimit: { label: 'Copay Day Limit', valueType: 'number' },
  coinsuranceCopayOrder: {
    label: 'Coinsurance Copay Order',
    valueType: 'number',
  },
  memberServicePaidCap: {
    label: 'Member Service Paid Cap',
    valueType: 'currency',
  },
  coverageVisitLimit: { label: 'Coverage Visit Limit', valueType: 'number' },
  firstDollarVisits: { label: 'First Dollar Visits', valueType: 'number' },
  copayAfterFirstVisits: {
    label: 'Copay After First Visits',
    valueType: 'number',
  },
  benefitDisplayValue: { label: 'Benefit Display Value', valueType: 'string' },
  notes: { label: 'Notes', valueType: 'string' },
}

export const IDENTITY_FIELDS = new Set([
  'year',
  'hiosPlanId',
  'state',
  'benefit',
])

export function coerceParamValue(
  field: string,
  value: unknown
): string | number | boolean | null {
  if (value === null || value === undefined) return null
  const valueType = FIELD_CONFIG[field]?.valueType
  if (valueType === 'boolean') return Boolean(value)
  if (valueType === 'number' || valueType === 'currency') {
    const n = Number(value)
    return isNaN(n) ? null : n
  }
  return String(value)
}
